import locales from '@/datasources/locales'

export default function (value, native = false) {
	if (!locales[value]) { return value }
	return native ? locales[value].nativeName : locales[value].name
}
